import React, { useEffect, useMemo, useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import Notify from "../../Common/Notify";
import PUBNUB from "pubnub";
import Parse from "parse";
import config from "../../../config";
import moment from "moment";
import Spinner from "../../Common/Spinner";
import Loader from "../../Common/Loader";
import { parseAction } from "../../../actions/REST";
import {
  generateQR,
  updateQueue,
  getQueueList,
  getQueue,
  getQueueCodeList,
  stopQueue,
} from "../../../actions/PatientAction";
import { demoQRQueueModalData } from "../../AppDemo/steps";
import QRCode from "react-qr-code";
import Modal from "../../Common/Modal";
import Logo from "../../../assets/images/logo-blue.png";
import "../../Pages/PatientTabs/PatientQueue/PatientQueue.css";
import "./QRQueueModal.css";

const $ = window.$;
let PubNub = null;
let subscribedChannels = null;

const QRQueueModal = ({
  isOpen = false,
  onClose = () => {},
}) => {
  const dispatch = useDispatch();

  const {
      qrQueueModalTab,
      qrQueueModalDemo,
    } = useSelector(
      (state) => ({
        qrQueueModalTab: state.global.qrQueueModalTab,
        qrQueueModalDemo: state.global.qrQueueModalDemo,
      }),
      shallowEqual,
    );

  const modalId = "#qr_code_modal";
  const [qrCode, setQRCode] = useState(null);
  const [current, setCurrent] = useState(null);

  const [queueList, setQueueList] = useState([]);
  const [queueCodeList, setQueueCodeList] = useState([]);
  const [queueCodeListDetails, setQueueCodeListDetails] = useState([]);

  const [tab, setTab] = useState("QR");
  const [openConfirm, setOpenConfirm] = useState(false);
  const [link, setLink] = useState("");
  const [pageQueue, setPageQueue] = useState(1);
  const [totalQueueList, setTotalQueueList] = useState({});
  const [hasMorequeueList, setHasMoreQueueList] = useState(true);
  const [filterStatus, setFilterStatus] = useState("open");
  const [filterLoading, setFilterLoading] = useState(false);
  const [viewQRCode, setViewQRCode] = useState("");
  const [isloadingDetails, setIsloading] = useState(false);
  const [isloadingCurrent, setIsloadingCurrent] = useState(false);
  const [demo, setDemo] = useState(null);
  const [isLoadingQRCode, setIsLoadingQRCode] = useState(false);
  const [isLoadingPK, setIsLoadingPK] = useState(false);
  const [showQRCode, setShowQRCode] = useState(false);

  const defQR = localStorage.getItem("current-qr-code");

  useEffect(() => {
    if ((defQR || isLoadingQRCode) && isLoadingPK) {
      setShowQRCode(true);
    }
  }, [isLoadingQRCode, isLoadingPK]);

  const listiningTo = {
    message: (m) => {
      var msg = m.message;
      if (msg.type === "get_queue_for_staff") {
        handleGetQueueList(defQR);

        setCurrent({
          ...current,
          current_serving: msg.currentServing,
          total_waiting: msg.total_waiting,
          contentAvailable: msg["content-available"],
        });
      }
    },
  };

  const tabs = {
    QR: "QR",
    CURRENT: "CURRENT",
    LIST: "LIST",
    HISTORY: "HISTORY",
  };

  useEffect(() => {
    if (qrQueueModalTab === null) return;
    handleNavBar(qrQueueModalTab);

  }, [qrQueueModalTab]);

  useEffect(() => {
    const uuid = Parse.User.current() ? Parse.User.current().id : "";
    if (qrQueueModalDemo === false) {
      setDemo(null);
      setCurrent(null);
      setQueueList([]);
      // setQueueCodeList([]);
    }
    if (localStorage.getItem("hubchart-app-demo-code-view-" + uuid)) return;

    const demoData = demoQRQueueModalData;
    setDemo(demoData.code);
    setCurrent(demoData.current);
    setQueueList(demoData.queueList);
    setShowQRCode(true);
    // setQueueCodeList(demoData.queueCodeList);

  }, [qrQueueModalDemo]);

  // LocalStorage QR CODE
  useEffect(() => {
    if (defQR === null) setShowQRCode(true);
    if (defQR) {
      setQRCode(defQR);
      // GET current active Queue details
      handleGetQueue(defQR);
      // GET current active Queue list
      handleGetQueueList(defQR);

      fetchPubNubKey(defQR);
      fetchPubNubKeyPublic(defQR);
    }
  }, [defQR]);

  // NEW QR CODE
  useEffect(() => {
    if (defQR === qrCode) return;
    if (qrCode) {
      // GET current active Queue details
      handleGetQueue(qrCode);
      // GET current active Queue list
      handleGetQueueList(qrCode);
      localStorage.setItem("current-qr-code", qrCode);

      fetchPubNubKey(qrCode);
      fetchPubNubKeyPublic(qrCode);
    }
  }, [qrCode]);

  // GET HISTORY Queue list
  useEffect(() => {
    setFilterLoading(true);
    handleGetQueueCodeList(1, "open", []);
  }, []);

  // GET HISTORY Queue details list
  useEffect(() => {
    if (viewQRCode === "") return;
    handleGetQueueList_Details(viewQRCode);
  }, [viewQRCode]);

  const handleOnClose = () => {
    if (!PubNub) {
      onClose();
      return;
    }
    if (listiningTo) {
      try {
        PubNub.removeListener(listiningTo);
      } catch (e) {
        // console.warn("Listener not attached", e);
      }
    }
    if (Array.isArray(subscribedChannels) && subscribedChannels.length > 0) {
      try {
        PubNub.unsubscribe({ channels: subscribedChannels });
      } catch (e) {
        // console.warn("Channels not subscribed", e);
      }
    }
    onClose();
  };

  const fetchPubNubKey = (defQR) => {
    parseAction("post", config.BASE_URL + "/parse/functions/getPubNubKeys")
      .then((keys) => {
        initializePubNub(keys.result, defQR);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const fetchPubNubKeyPublic = (defQR) => {
    parseAction(
      "post",
      config.BASE_URL + "/parse/functions/getPublicPubNubKeys",
    )
      .then((keys) => {
        const pub = keys.result.publishKey;
        const sub = keys.result.subscribeKey;
        setLink(
          `https://web.hubchart.net/patient-queue/${defQR}/${pub}/${sub}`,
        );
        setIsLoadingPK(true);
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  const initializePubNub = (keys, defQR) => {
    PubNub = new PUBNUB({
      publish_key: keys.publishKey,
      subscribe_key: keys.subscribeKey,
      ssl: window.location.protocol.toLowerCase() === "https:",
      origin: "pubsub.pubnub.com",
      uuid: Parse.User.current().id,
      presenceTimeout: 120,
      heartbeatInterval: 30,
    });

    PubNub.addListener(listiningTo);
    subscribedChannels = ["queue_staff_channel_" + defQR];
    PubNub.subscribe({ channels: subscribedChannels });
  };

  const generateQRCode = () => {
    setShowQRCode(false);
    dispatch(generateQR()).then((res) => {
      const code = res.queuing_code.code;
      setQRCode(code);
      setIsLoadingQRCode(true);
    });
  };

  const handleGetQueueList = (qrCode) => {
    setIsloading(true);
    setIsloadingCurrent(true);
    const params = { queue_code: qrCode };

    dispatch(getQueueList(params)).then((res) => {
      if (res && res.queue_list) {
        setQueueList(res.queue_list.reverse());
        setIsloadingCurrent(false);
        setIsloading(false);
      }
    });
  };

  const handleGetQueueList_Details = (qrCode) => {
    setIsloading(true);
    setIsloadingCurrent(true);
    const params = { queue_code: qrCode };

    dispatch(getQueueList(params))
    .then((res) => {
      if (res && res.queue_list) {
        setQueueCodeListDetails(res.queue_list.reverse());
        setIsloading(false);
        setIsloadingCurrent(false);
      }
    });
  };

  const handleNavBar = (newTab) => {
    if (newTab === tab) return;
    setTab(newTab);
  };

  const handleUpdateQueue = () => {
    const params = { code: qrCode };
    dispatch(updateQueue(params)).then((res) => {
      if (res && !res.error_message) {
        Notify.info("Updated next queue");

        const wait = current.total_waiting > 0 ? current.total_waiting - 1 : 0;
        setCurrent({
          current_serving: res.now_serving,
          patient: res.patient_name,
          total_waiting: wait,
        });
      } else {
        Notify.info("No more queue available");
        setCurrent({
          current_serving: null,
          patient: "",
          total_waiting: 0,
        });
      }
    });
  };

  const handleGetQueue = (code) => {
    const params = { queue_code: code };
    dispatch(getQueue(params)).then((res) => {
      setCurrent(res);
    });
  };

  const handleStopQueue = () => {
    localStorage.removeItem("current-qr-code");
    setIsLoadingQRCode(false);
    setIsLoadingPK(false);
    setQRCode(null);
    setCurrent(null);
    handleNavBar(tabs.QR);
    setOpenConfirm(false);
    setQueueList([]);
    setLink("");
    PubNub.removeListener(listiningTo);
    PubNub.unsubscribe({
      channels: subscribedChannels,
    });
    dispatch(stopQueue(qrCode))
      .then((res) => {
        if (res === "closed") {
          Notify.info("Successfully stop queue");
        }
      });
  };

  const handleGetQueueCodeList = (page, status, list) => {
    const params = {
      status: status,
      page: page,
      pageSize: 20,
    };
    dispatch(getQueueCodeList(params))
    .then((res) => {
      setQueueCodeList([...list, ...res.openQueueList]);
      setIsloading(false);
      setFilterLoading(false);
      setPageQueue(page);
      if (res.pagination) {
        setTotalQueueList(res.pagination.totalCount);
        setHasMoreQueueList(res.pagination.hasMore);
      }    
    });
  };

  const handleFilterViewQueueList = (filter) => {
    if (filterStatus === filter) return;
    setFilterLoading(true);
    setFilterStatus(filter);
    setQueueCodeList([]);
    handleGetQueueCodeList(1, filter, []);
  };

  const handleScroll = (event) => {
    const { scrollHeight, scrollTop, clientHeight, id } = event.target;
    if (id === "") return;
    const bottom =
      Math.round(scrollHeight) - Math.round(scrollTop) + 1 === clientHeight ||
      Math.round(scrollHeight) - Math.round(scrollTop) - 1 === clientHeight;

    if (bottom) {
      if (id === "queue-list-table" && hasMorequeueList) {
        handleGetQueueCodeList(pageQueue + 1, filterStatus, queueCodeList);
      }
      // if (id === "queue-list-table-details") {}
    }
  };

  useEffect(() => {
    if (isOpen) {
      $(modalId).modal({
        backdrop: "static",
        keyboard: false
      });
      $(modalId).css({
        "z-index": "3000",
        "position": "fixed"
      });
      $(modalId).modal("show");
    } else {
      handleNavBar(tabs.QR);
      setShowQRCode(false);
      $(modalId).modal("hide");
    }

    return () => {
      $(modalId).modal("hide");
      $(".modal-backdrop").remove();
      $("body").removeClass("modal-open").css("padding-right", "");
    };
  }, [isOpen, modalId]);

  return (
    <div id="qr_code_modal" className="qr-code-modal-container">
      <Modal shown={isOpen} onHide={handleOnClose}>
        <ModalHeader />
        <div className="QRQueueModal-navbar">
          <ul className="nav nav-pills nav-justified hc-nav-pills queue-main-nav">
            <li className="nav-item">
              <a
                onClick={() => handleNavBar(tabs.QR)}
                className={
                  tab === tabs.QR
                    ? "queue-main-nav-link-active"
                    : "queue-main-nav-link"
                }
                href="#"
              >
                <i
                  className="fad fa-fw fa-qrcode fa-lg"
                  style={{ marginTop: "3px" }}
                ></i>{" "}
                QR
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => handleNavBar(tabs.CURRENT)}
                className={
                  tab === tabs.CURRENT
                    ? "queue-main-nav-link-active"
                    : "queue-main-nav-link"
                }
                href="#"
              >
                <i className="fa fa-user-check" style={{ marginTop: "3px" }}></i>{" "}
                Now Serving
              </a>
            </li>
            <li className="nav-item">
              <a
                onClick={() => {
                  handleNavBar(tabs.LIST);
                  setViewQRCode("");
                }}
                className={
                  tab === tabs.LIST
                    ? "queue-main-nav-link-active"
                    : "queue-main-nav-link"
                }
                href="#"
              >
                <i className="fad fa-list" style={{ marginTop: "3px" }}></i> Queue
                List
              </a>
            </li>
          </ul>
        </div>
        <ModalBody
          style={{
            margin: current ? "0px 30px" : "0px 30px",
            padding: "0px 1rem",
          }}
        >
          {tab === tabs.QR && (
            <div className="container-main">
              <div id="hc-nav-qr-code" className="code-qr">
                {(qrCode || demo) ? (
                  <QRCode value={demo ? demo : link} size={300} />
                ) : (
                  <div class="empty-qr">
                    <i class="fas fa-qrcode fa-2x" />
                    <span>QR code will appear here</span>
                  </div>
                )}
              </div>
              {showQRCode ? (
                (link && !demo) ? (
                  <React.Fragment>
                    <div className="code-desc">Scan QR code or click on link</div>
                    <a
                      className="footer-brand"
                      href={link}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        className="d-none d-sm-inline"
                        width="40"
                        height="40"
                        src={Logo}
                        alt="H"
                      ></img>
                      <span
                        className="hc-primary-text d-none d-md-inline"
                        style={{ fontWeight: "500" }}
                      >
                        HUBCHART
                      </span>
                    </a>
                    <button
                      type="button"
                      style={{
                        width: "100%",
                      }}
                      className="btn btn-danger btn-circle btn-large"
                      onClick={() => setOpenConfirm(true)}
                    >
                      Stop Queue
                    </button>
                  </React.Fragment>
                ) : (
                  <button
                    id="hc-nav-qr-generate"
                    type="button"
                    className="btn btn-primary btn-circle btn-large"
                    style={{
                      width: "100%",
                    }}
                    onClick={() => generateQRCode()}
                  >
                    Start Queue & Generate QR
                  </button>
                )
              ) : (
                <CustomLoader isLoading={!showQRCode} />
              )}
            </div>
          )}
          {tab === tabs.CURRENT && (
            <div className="QRQueueModal-current" id="qr-code-id-2">
              {current ? (
                <div className="QRQueueModal-curret-main">
                  <div style={{ fontWeight: "bold" }}>CURRENT PATIENT</div>
                  <span>
                    {current.current_serving ? current.current_serving : "--"}
                  </span>
                </div>
              ) : (
                ""
              )}
              <button
                id="hc-nav-qr-patient-next"
                className="btn btn-primary hc-bg-primary btn-circle btn-large"
                disabled={link === null || isloadingCurrent}
                onClick={() => handleUpdateQueue()}
              >
                Next Patient
              </button>
              <div className="current-queue-details">
                <span>Total Waiting</span>
                <span>{current ? current.total_waiting : "0"}</span>
              </div>
              <div style={{ textAlign: "center" }}>Patient List</div>
              <div id="hc-nav-qr-patient-list" className="patient-list-table">
                {queueList.length === 0 && !isloadingCurrent ? (
                  <div className="em-container">
                    <em>No patient found</em>
                  </div>
                ) : (
                  <>
                    {isloadingCurrent && (
                      <div align="center" style={{ marginTop: "10px" }}>
                        <Spinner size={5} loading={isloadingCurrent} />
                      </div>
                    )}
                    {!isloadingCurrent &&
                      queueList.map((i, index) => (
                        <ItemPatientQueue data={i} index={index} />
                      ))}
                  </>
                )}
              </div>
            </div>
          )}
          {tab === tabs.LIST && (
            <div id="qr-code-id-3">
              {/* {isloadingDetails && <CustomLoader isLoading={isloadingDetails} />} */}
              {viewQRCode === "" && !isloadingDetails ? (
                <React.Fragment>
                  <ul className="nav nav-pills nav-justified hc-nav-pills queue-list-nav">
                    <li className="nav-item">
                      <a
                        id="hc-nav-qr-list-open"
                        onClick={() => handleFilterViewQueueList("open")}
                        className={
                          filterStatus === "open"
                            ? "queue-list-nav-link-active"
                            : "queue-list-nav-link"
                        }
                        href="#"
                      >
                        OPEN
                      </a>
                    </li>
                    <li className="nav-item">
                      <a
                        id="hc-nav-qr-list-close"
                        onClick={() => handleFilterViewQueueList("close")}
                        className={
                          filterStatus === "close"
                            ? "queue-list-nav-link-active"
                            : "queue-list-nav-link"
                        }
                        href="#"
                      >
                        CLOSE
                      </a>
                    </li>
                  </ul>
                  {queueCodeList.length === 0 && !filterLoading ? (
                    <div className="em-container">
                      <em>No QR code found</em>
                    </div>
                  ) : (
                    <>
                      <div
                        id="queue-list-table"
                        className="queue-list-table"
                        onScroll={handleScroll}
                      >
                        {queueCodeList.map((i, index) => (
                          <ItemQRCode
                            data={i}
                            index={index}
                            setViewQRCode={setViewQRCode}
                          />
                        ))}
                        {filterLoading && (
                          <div align="center" style={{ marginTop: "10px" }}>
                            <Spinner size={5} loading={filterLoading} />
                          </div>
                        )}
                        {hasMorequeueList && !filterLoading && (
                          <div align="center">
                            <Spinner size={5} loading={hasMorequeueList} />
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </React.Fragment>
              ) : (
                // View QR Code patient list
                <div>
                  {queueCodeListDetails.length === 0 && !isloadingDetails ? (
                    <div className="em-container">
                      <em>No patient found</em>
                    </div>
                  ) : (
                    <React.Fragment>
                      {isloadingDetails && (
                        <div align="center" style={{ marginTop: "10px" }}>
                          <Spinner size={5} loading={isloadingDetails} />
                        </div>
                      )}
                      {!isloadingDetails && (
                        <React.Fragment>
                          <div className="queue-list-code-qr">
                            <QRCode value={link} size={200} />
                          </div>
                          <div
                            id="queue-list-table-details"
                            className="queue-list-table-details"
                            onScroll={handleScroll}
                          >
                            {queueCodeListDetails.map((i, index) => (
                              <ItemPatientQueue data={i} index={index} />
                            ))}
                          </div>
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  )}
                </div>
              )}
            </div>
          )}
        </ModalBody>
        <ModalFooter></ModalFooter>
        {openConfirm && (
          <Confirmation
            handleStopQueue={() => handleStopQueue()}
            onClose={setOpenConfirm}
          />
        )}
      </Modal>
    </div>
  );
};

const ItemPatientQueue = (props) => {
  return (
    <div className="item-patient-queue-row">
      <div>{props.data.ticket_number}</div>
      <div>
        <div>{props.data.name}</div>
        <div>{props.data.mobile_number}</div>
      </div>
      <div>{props.data.status.toUpperCase()}</div>
    </div>
  );
};

const ItemQRCode = ({ data, setViewQRCode = () => {} }) => {
  return (
    <a
      className="dropdown-item d-flex flex-row item-result"
      href="#"
      style={{ border: "1px solid rgb(229, 229, 229)", placeItems: "center" }}
      onClick={() => setViewQRCode(data.code)}
    >
      <i class="fas fa-qrcode fa-2x mr-1 ml-1" />
      <div className="qrcode-list-details">
        <div className="ml-1">{data.generator ? data.generator.displayName : ""}</div>
        <div className="ml-1 text-small" style={{ color: "grey" }}>
          {data.code ? data.code : ""}
        </div>
      </div>
      <div className="text-secondary text-xs" style={{ marginLeft: "auto" }}>
        <span>{moment(data.createdAt).format("MMM D, h:mm a")}</span>
      </div>
    </a>
  );
};

const Confirmation = ({ handleStopQueue, onClose = () => {} }) => {
  return (
    <div className="assignment-notify-container">
      <div className="attention-notify-box" style={{ width: "auto" }}>
        <div className="save-changes-flex">
          <h6 style={{ fontWeight: "bold" }}>Stop current Queue?</h6>
          <h6>This will delete all current waiting queue.</h6>
          <div style={{ textAlign: "right", marginTop: 10 }}>
            <button
              type="button btn-sm"
              style={{ marginRight: "10px" }}
              className="btn btn-danger"
              onClick={() => handleStopQueue()}
            >
              Stop
            </button>
            <button
              type="button btn-sm"
              className="btn btn-hubchart btn-hubchart-close"
              onClick={() => onClose(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const CustomLoader = ({ isLoading }) => {
  return (
    <div
      className="loader"
      style={{
        display: isLoading ? "inline-grid" : "none",
        position: "absolute",
        overflow: "hidden",
        backgroundColor: "#ffffff",
      }}
    >
      <div align="center">
        <div className="loader-container">
          <div>
            <div className="loader-message">
              <span>Please wait...</span>
              <Spinner size={5} loading={isLoading} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const ModalHeader = () => {
  return (
    <div className="modal-header">
      <h5 className="text-primary mb-0" style={{ fontSize: "1.25rem" }}>
        <i className="fas fa-qrcode mr-1"></i>
        QR CODE
      </h5>
      <button
        type="button"
        className="close"
        data-dismiss="modal"
        aria-label="Close"
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
};

const ModalBody = ({ children, style = {} }) => {
  const styles = {
    ...style,
  };

  return (
    <div className="modal-body" style={styles}>
      {children}
    </div>
  );
};

const ModalFooter = ({ children }) => {
  return <div className="modal-footer">{children}</div>;
};

export default QRQueueModal;
